import React, { useEffect } from "react";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { actionCreators } from "./redux/onDemandRevenueSagas";
import { useDispatch, useSelector } from "react-redux";
import CustomDateRanges from "./smartComponents/customDateRanges";
import DatePicker from "./smartComponents/datePicker";
import SourceCategory from "./smartComponents/sourceCategory";
import SubscriptionFilter from "./smartComponents/subscriptionFilter";
import GroupBySubscription from "./smartComponents/groupBySubscription";
import PeriodType from "./smartComponents/periodType";
import TableOrStackedBarChart from "./smartComponents/tableOrStackedBarChart";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { UpdateButtons } from "./smartComponents/UpdateButtons";

const OnDemandRevenueModule = (props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.onDemandRevenue.isLoading);
  const isUpdating = useSelector((state) => state.onDemandRevenue.isUpdating);

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = () => {
    return (
      <div id="onDemandRevenue">
        <div className="edit-selections-bar">
          <div className="main-filters">
            <div className="fixed-width-wrapper">
              <div className="select-box-no-width">
                <p>Source</p>
                <SourceCategory />
              </div>
              <div className="select-box-no-width">
                <p>Subscription</p>
                <SubscriptionFilter />
              </div>
            </div>
            <div className="check-in-toggle">
              <p>Group by Subscription</p>
              <GroupBySubscription />
            </div>
          </div>

          <div className="date-filters-wrapper">
            <div className="select-box-no-width">
              <p>Period Type</p>
              <PeriodType />
            </div>
            <div className="select-box" style={{ width: "360px" }}>
              <p className="offers-title">Date Range</p>
              <CustomDateRanges />
            </div>
            <div className="date-select-box select-box multi" style={{ width: "286px" }}>
              <p className="offers-title">Date</p>
              <DatePicker />
            </div>
            <UpdateButtons />
          </div>
        </div>
        <div className="chart-root">
          {isUpdating ? <LoadingAnimation text="Updating data..." /> : <TableOrStackedBarChart />}
        </div>
      </div>
    );
  };
  return (
    <SectionToggle
      isLoading={isLoading}
      title="On Demand Revenue"
      content={content()}
      learnMore={<></>}
    />
  );
};

export default OnDemandRevenueModule;
